import { useLingui } from '@lingui/react/macro';
import { WinRuleProps } from 'modules/championship/ui/components/form-parts/rules/types';
import React, { ReactNode } from 'react';
import { UDFormLabeledInput } from 'ud-form/components';
import { UDSectionTitle } from 'ud-ui/components';

interface ExtendedWinRuleProps extends WinRuleProps {
  children?: ReactNode;
}

const WinBase: React.FC<ExtendedWinRuleProps> = ({ sportType = 'general', children }) => {
  const { t } = useLingui();

  return (
    <>
      <UDSectionTitle
        title={t`Победа`}
        icon="🏆"
        tooltip={t`Настройка очков, которые получает команда за победу в разных сценариях.`}
      />

      <UDFormLabeledInput
        name="settings.winScore"
        placeholder={t`0 очков`}
        label=""
        containerClassName="mb-4"
        inputContainerClassName="min-w-[120px]"
        alignRight={false}
        tooltip={t`Количество очков за победу в основное время матча`}
        tooltipProps={{ position: 'input-right' }}
      />

      <UDFormLabeledInput
        name="settings.winScoreExtraTime"
        placeholder={t`0 очков`}
        label={t`В дополнительное время`}
        tooltip={t`Количество очков за победу, если матч завершился в дополнительное время (особенно важно в играх, где есть возможность ничьей).`}
        tooltipProps={{ position: 'input-right' }}
      />

      {/* Место для дополнительных полей */}
      {children}
    </>
  );
};

export default WinBase;
